<template>
    <div id="teamChatPage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="open" class="container d-flex flex-column">
            <div class="row align-strach">
                <div class="col-md-6 h-100 m-auto text-center d-flex flex-column">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('team.messages_title') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>
                    <div class="d-flex justify-content-center mb-4">
                        <img src="/images/home/teams/chat-team-bg.png" style="height: 12vh;"/>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="open" class="chat-list-holder">
            <div v-if="loading" class="d-flex h-100">
                <div class="m-auto text-center">
                    <h5 class="mb-5">{{ $t('base.loading') }}</h5>
                </div>
            </div>
            <div v-else-if="messages.length == 0" class="d-flex h-100">
                <div class="m-auto text-center">
                    <img src="/images/icon-chat.png" class="vh-10 mb-3"/>
                    <h5 class="mb-2">{{ $t('team.messages_no_msg_title') }}</h5>
                    <div class="small mb-5">{{ $t('team.messages_no_msg_text') }}</div>
                </div>
            </div>
            <div v-else class="container d-flex flex-column">
                <div class="row align-strach">
                    <div class="col-md-6 h-100 m-auto text-center d-flex flex-column">
                        <ul class="chat-list">
                            <li v-for="m in messages" :key="m.id" :class="{ 'chat-item--my' : m.user.id == user.id, 'animate__animated animate__zoomIn animate__faster' : animateId == m.id }">
                                <div class="chat-item__image">
                                    <img :src="m.user.avatarUrl != undefined ? m.user.avatarUrl : '/images/male-default.png'" class="profileImage"/>
                                </div>
                                <div class="chat-item__content">
                                    <div v-if="m.user.id != user.id" class="text-primary small">
                                        <b>{{ m.user.username }}</b>
                                    </div>
                                    <p>{{ m.text }}</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div v-if="showPredefined" class="predefinedMessages">
                <div class="animate__animated animate__slideInUp animate__faster">
                    <div class="container d-flex flex-column">
                        <div class="row m-0">
                            <div v-for="p,index in predefined" :key="p.id" class="col-6 col-lg-4 p-2">
                                <b-button @click="sendMessage(p.id);btnSfx();" variant="light" block :style="{ 'border-color': colors[index % colors.length] }">
                                    {{ p.text }}
                                </b-button>
                            </div>
                        </div>
                        <div class="text-center pt-2">
                            <b-button @click="showPredefined = false;btnSfx();" variant="close-circle"></b-button>
                        </div>
                    </div>
                </div>
            </div>
            <b-button v-if="!showPredefined" @click="showPredefined = true;btnSfx();" variant="hexagon" class="chat"><i></i></b-button>                    
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

import api from '../../api'
import io from '../../socketio';


const ChatPopup = Vue.component('team-chat-popup', {
    data() {
        return {
            loading: false,
            open: false,
            predefined: [],
            messages: [],
            token: undefined,
            showPredefined: false,
            animateId: undefined,
            colors: ["#2B7FB8", "#FF8500", "#62B270", "#297EB7","#8077AF"]
        }
    },
    computed: {
        user() {
            return this.$store.state.auth.user;
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },
        
        show() {
            this.open = true;
            this.loading = true;

            // JOIN to room
            if(this.user.team != undefined && this.token != this.user.team.token){
                if(this.token != undefined){
                    io.io.emit('leave', { room: "team-chat:" + this.token });
                }

                io.io.emit('join', { room: "team-chat:" + this.user.team.token });
                this.token = this.user.team.token;
            }

            this.loadMessages();

            // load predefined messages
            if(this.predefined.length == 0){
                const $this = this;
                api.teamMessagesPredefined()
                .then(res => {
                    $this.predefined = res.data;
                });
            }
        },
        
        hide() {
            this.loading = false;
            this.open = false;
        }, 

        sendMessage(id){
            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.teamMessagesSend(id)
            .then(res => {
                $this.showPredefined = false;
                $this.onTeamMessage(res.data, true);
            })
            .catch(err => {
                api.baseErrorHendler(err);
            })
            .then(function () {
                loader.classList.remove("show");
            });
        },

        onTeamMessage(data){
            if(this.messages.find(x => x.id == data.id)) 
                return;

            // add message to list
            this.messages.push(data);
            this.animateId = data.id;
            this.$store.dispatch('sound/sfx','Message');

            var list = document.querySelector("#teamChatPage .chat-list-holder");
            if(list != undefined && (data.user.id == this.user.id || (list.scrollTop + list.clientHeight + 40) >= list.scrollHeight))
                this.scrollToEnd();
        },
        
        scrollToEnd(){
            this.$nextTick(() => {
                var list = document.querySelector("#teamChatPage .chat-list-holder");
                if(list != undefined) 
                    list.scrollTop = list.scrollHeight;
            });
        },

        loadMessages(){
            const $this = this;
            this.messages = [];
            this.animateId = undefined;
            this.loading = true;

            api.teamMessages()
            .then(res => {
                $this.loading = false;
                $this.messages = res.data.reverse();
                $this.scrollToEnd();
            })
            .catch(err => {
                $this.loading = false;
                api.baseErrorHendler(err);
            });
        },
        
    },
    created(){
        
        // socket subscribe
        io.io.on('TEAM_MESSAGE', this.onTeamMessage); 
        
        
    },
    beforeDestroy(){
        io.io.off('TEAM_MESSAGE', this.onTeamMessage);
    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        },
    }
})

export default ChatPopup
</script>